import cn from 'classnames';
import { ResponsiveBar } from '@nivo/bar';
import PropTypes from 'prop-types';

import { AnalyticsItemBox } from '../pages/Analytics/AnalyticsItemBox';
import { EmptyChart } from '../pages/Analytics/EmptyChart';
import { BestSellersProductDescription } from './legends/BestSellersProductDescription';
import { BestSellersTotals } from './legends/BestSellersTotals';
import { BestSellersTooltip } from './tooltips/BestSellersTooltip';
import { BestSellersLegend } from './legends/BestSellersLegend';

import { getBarHeight } from './legends/best-sellers.utils';
import { graphCurrencyFormatter, graphNumberFormatter } from './utils';
import { graphColors, graphTheme } from './consts';

import styles from './graph.module.scss';

export function BestSellersByChannels(props) {
  const { data, keys, title, metric, isGmvMetric, currency, uiDataKey } = props;

  const uiData = data[uiDataKey];

  if (!uiData) return null;

  return (
    <AnalyticsItemBox title={title} metric={metric}>
      <div className={cn(styles.graphWrapper, styles.barGraph, uiData.length === 0 ? styles.noData : '')}>
        {uiData.length > 0 ? (
          <ResponsiveBar
            data={uiData}
            keys={keys}
            indexBy="model"
            layout="horizontal"
            margin={{ top: 16, right: 48, bottom: 20, left: 160 }}
            enableGridX={false}
            enableGridY={true}
            valueFormat={(value) =>
              isGmvMetric ? graphCurrencyFormatter(value, currency) : graphNumberFormatter(value)
            }
            padding={0.35}
            innerPadding={1}
            labelSkipWidth={25}
            theme={{
              ...graphTheme,
              grid: {
                line: {
                  stroke: '#f6f6f6',
                  strokeWidth: getBarHeight(uiData.length),
                },
              },
            }}
            colors={graphColors}
            layers={[
              'grid',
              'bars',
              BestSellersProductDescription(),
              BestSellersTotals(isGmvMetric, currency),
              BestSellersLegend(isGmvMetric, currency),
            ]}
            borderRadius={2}
            borderColor="rgba(0, 0, 0, 0.08)"
            borderWidth={1}
            tooltip={BestSellersTooltip({
              allData: data,
              keys,
              isGmvMetric,
              currency,
            })}
          />
        ) : (
          <EmptyChart />
        )}
      </div>
    </AnalyticsItemBox>
  );
}

BestSellersByChannels.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    gmv: PropTypes.arrayOf(PropTypes.object),
    units: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  metric: PropTypes.string,
  currency: PropTypes.string,
  isGmvMetric: PropTypes.bool,
};
